/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetAlternativesResponse,
  UtxAlternativesGetListParams,
  AlternativesOverviewResponse
} from './schema'



export const utxAlternativesGetList = (
    params?: UtxAlternativesGetListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAlternativesResponse>> => {
    return axios.get(
      `/alternatives`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxAlternativesGetListQueryKey = (params?: UtxAlternativesGetListParams,) => [`/alternatives`, ...(params ? [params]: [])];

    
export type UtxAlternativesGetListQueryResult = NonNullable<Awaited<ReturnType<typeof utxAlternativesGetList>>>
export type UtxAlternativesGetListQueryError = AxiosError<void>

export const useUtxAlternativesGetList = <TData = Awaited<ReturnType<typeof utxAlternativesGetList>>, TError = AxiosError<void>>(
 params?: UtxAlternativesGetListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxAlternativesGetList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxAlternativesGetListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxAlternativesGetList>>> = ({ signal }) => utxAlternativesGetList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxAlternativesGetList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxAlternativesGetAlternativeOverview = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AlternativesOverviewResponse>> => {
    return axios.get(
      `/alternatives/overview`,options
    );
  }


export const getUtxAlternativesGetAlternativeOverviewQueryKey = () => [`/alternatives/overview`];

    
export type UtxAlternativesGetAlternativeOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof utxAlternativesGetAlternativeOverview>>>
export type UtxAlternativesGetAlternativeOverviewQueryError = AxiosError<void>

export const useUtxAlternativesGetAlternativeOverview = <TData = Awaited<ReturnType<typeof utxAlternativesGetAlternativeOverview>>, TError = AxiosError<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxAlternativesGetAlternativeOverview>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxAlternativesGetAlternativeOverviewQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxAlternativesGetAlternativeOverview>>> = ({ signal }) => utxAlternativesGetAlternativeOverview({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxAlternativesGetAlternativeOverview>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

